import { render, staticRenderFns } from "./TreeSelectorDemo.vue?vue&type=template&id=6690056a&scoped=true"
import script from "./TreeSelectorDemo.vue?vue&type=script&lang=js"
export * from "./TreeSelectorDemo.vue?vue&type=script&lang=js"
import style0 from "./TreeSelectorDemo.vue?vue&type=style&index=0&id=6690056a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6690056a",
  null
  
)

export default component.exports